// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"300":"b7851786","533":"454bc331","588":"b7851786","977":"b7851786"}[chunkId] + ".chunk.css";
};